import { render, staticRenderFns } from "./TouchFullScreen.vue?vue&type=template&id=8e81ce54&scoped=true"
import script from "./TouchFullScreen.vue?vue&type=script&lang=ts"
export * from "./TouchFullScreen.vue?vue&type=script&lang=ts"
import style0 from "./TouchFullScreen.vue?vue&type=style&index=0&id=8e81ce54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e81ce54",
  null
  
)

export default component.exports